import React, {PureComponent} from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import i18n from '../../../utils/i18n';
import {
  default as TextInput,
  Behaviors as TextInputBehaviors,
  InputUITypes,
  ValidationTypes
} from '@adsk/bim360-matrix-react-text-input';
import {issueTypeInputValidators, subIssueTypeInputValidators} from '../../../utils/issueTypes-helpers';
import {stopPropagation} from '../../../utils/dom-helpers';

class IssueTypesAdminTitle extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      value: props.value || '',
      editableProps: this.getEditableProps(props)
    };

    this.inputProps = {
      autoselect: !!props.value,
      behavior: TextInputBehaviors.SINGLE_LINE,
      onChange: value => this.setState({value}),
      onInlineEditStart: () => this.props.onTitleEditStart(),
      onInlineEditEnd: (value, isCancel, previousValue, finisher, valid) => {
        if (valid || value.length === 0) {
          value.length > 0 && !isCancel && this.onChangeEnd(value);
          this.setState({value: this.props.value || ''});
          this.props.onTitleEditEnd();
        }
      },
      className: 'IssueTypesAdminTitle__input'
    };

    this.onClick = this.onClick.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.value !== nextProps.value) {
      this.setState({
        value: nextProps.value || '',
        editableProps: this.getEditableProps(nextProps)
      });
    }
  }

  getEditableProps(props) {
    const editableClassName = cx('IssueTypesAdminTitle__editable', {
      'IssueTypesAdminTitle__editable--add-sub-type': !props.entityId
    });

    return {
      startInEdit: false,
      showEditableIcon: !!props.entityId,
      className: editableClassName
    };
  }

  createSubType(title) {
    this.props.createIssueSubTypeAction({
      parentId: this.props.parentId,
      title: title.trim(),
      clientID: this.props.clientID,
      isActive: this.props.parentStatus
    });
    this.props.onCreate();
  }

  setTitle(id, value) {
    this.props.updateIssueTypeTitleAction(id, value, this.props.parentId);
  }

  getValidationProps() {
    const issueTypeNames = this.props.issueTypeNames.filter(name => name !== this.props.value.toLowerCase());
    return {
      type: ValidationTypes.POPOVER,
      ignore: this.props.value === this.state.value,
      validator: this.props.isParent
        ? issueTypeInputValidators(issueTypeNames)
        : subIssueTypeInputValidators(issueTypeNames),
      required: true,
      typeProps: {
        container: this.props.container,
        tooltipClassName: 'IssueTypesAdminTitle__popover'
      }
    };
  }

  onChangeEnd(value) {
    if (this.props.value && value && this.props.value !== value) {
      this.setTitle(this.props.entityId, value);
    } else if (!this.props.value) {
      this.createSubType(value);
    }
  }

  onClick(event) {
    if (!this.props.isReadOnly) {
      stopPropagation(event);
    }
  }

  _renderTitle() {
    return <span>{this.props.value}</span>;
  }

  _renderInput() {
    // When editing an existing issue type / sub-type, don't show placeholder
    const placeholder = this.props.entityId
      ? ''
      : this.props.isParent
        ? i18n.t('issueTypes.actions.addType')
        : i18n.t('issueTypes.actions.addSubType');
    return (
      <TextInput
        placeholder={placeholder}
        inputUIType={InputUITypes.INLINE_EDIT}
        validationProps={this.getValidationProps()}
        editableProps={this.state.editableProps}
        inputProps={this.inputProps}
        value={this.state.value}
      />
    );
  }

  render() {
    return <span onClick={this.onClick}>{this.props.isReadOnly ? this._renderTitle() : this._renderInput()}</span>;
  }
}

IssueTypesAdminTitle.displayName = 'IssueTypesAdminTitle';

IssueTypesAdminTitle.defaultProps = {
  parentStatus: null,
  isReadOnly: false
};

IssueTypesAdminTitle.propTypes = {
  value: PropTypes.string,
  entityId: PropTypes.string,
  parentId: PropTypes.string,
  issueTypeNames: PropTypes.arrayOf(PropTypes.string).isRequired,
  container: PropTypes.object.isRequired,
  parentStatus: PropTypes.bool,
  isParent: PropTypes.bool.isRequired,
  isReadOnly: PropTypes.bool,
  createIssueSubTypeAction: PropTypes.func.isRequired,
  updateIssueTypeTitleAction: PropTypes.func.isRequired,
  clientID: PropTypes.string,
  onTitleEditStart: PropTypes.func.isRequired,
  onTitleEditEnd: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired
};

export default IssueTypesAdminTitle;
